import { ErrorMsg } from 'commonTypes'
import React, { ForwardedRef, forwardRef, MutableRefObject } from 'react'
import { useTranslation } from 'react-i18next'
import { useReportMenuFrameStyles } from './ReportMenuCommonLayout.styles'
import { PageError } from '../pageError/PageError'
import ReportMenuCommonLayoutLoadingState from '../reportMenuCommonLayoutLoadingState/ReportMenuCommonLayoutLoadingState'

type ReportMenuFrameProps = {
    isLoading: boolean
    isMenuOpen: boolean
    title: string
    subtitle: string
    tableTitle: string
    tableSubTitle?: string
    targetUrl: string
    error: boolean
    errorMsg?: ErrorMsg
    scrollRef: MutableRefObject<any>
    hasFilters?: boolean
    children: React.ReactNode
}

const ReportMenuCommonLayout = (
    {
        isLoading,
        isMenuOpen,
        title,
        subtitle,
        tableTitle,
        tableSubTitle,
        targetUrl,
        error,
        errorMsg,
        scrollRef,
        hasFilters,
        children
    }: ReportMenuFrameProps,
    ref: ForwardedRef<any>
) => {
    const styles = useReportMenuFrameStyles()
    const { t } = useTranslation('common')

    return (
        <React.Fragment>
            {error ? (
                <PageError
                    title={t(`common:${errorMsg?.title}`)}
                    description={t(`common:${errorMsg?.description}`)}
                />
            ) : (
                <React.Fragment>
                    {isLoading ? (
                        <ReportMenuCommonLayoutLoadingState
                            title={title}
                            subtitle={subtitle}
                            tableTitle={tableTitle}
                            tableSubTitle={tableSubTitle}
                            showFilter={hasFilters}
                            isMenuOpen={isMenuOpen}
                        />
                    ) : (
                        <div className={styles.container} ref={ref}>
                            <div className={styles.subheaderContainer}>
                                <div>
                                    <h2 className={styles.title}>{title}</h2>
                                    <p className={styles.subtitle}>
                                        {subtitle}
                                    </p>
                                </div>
                            </div>
                            <div ref={scrollRef}>{children}</div>
                        </div>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default forwardRef(ReportMenuCommonLayout)
